import { createFileRoute } from '@tanstack/react-router';
import { ConversationsOverview } from '@/features/conversations/Overview';

export const Route = createFileRoute('/app/conversations/')({
  component: ConversationsOverview,
  staticData: { title: 'Conversations' },
});
